import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { OneiProvider } from 'react-onei';

import './index.css';

import App from './App';
import ErrorBoundary from './ErrorBoundary';

// if (process.env.NODE_ENV !== 'production') {
//   var axe = require('react-axe');
//   axe(React, ReactDOM, 1000);
// }

ReactDOM.render(
  <OneiProvider theme={window.o_confCommon.isSosh ? 'sosh' : 'orange'}>
    <BrowserRouter>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </BrowserRouter>
  </OneiProvider>,
  document.getElementById('root'),
);
